import "./IndustryRelatedVTwoStyles.scss";
import { industryCountryCrawl } from "../IndustryCountryCrawl/IndustryCountryCrawl";
const industryRelatedVTwo = () => {
    // TOOD Fix
    industryCountryCrawl();
};
export { industryRelatedVTwo };
